import { hasRestorableAgenticSnapshotBundle } from "src/lib/agenticChatSnapshotBundle";

export interface RevertOption {
  snapshotId?: string;
  outlineId?: string;
  projectId?: string;
  chatId: string;
  userMessageId: string;
  userMessageContent: string;
  snapshotBundle?: {
    outlineSnapshotId: string | null;
    outlineId: string | null;
    characterSnapshots: Record<string, string>;
    worldbuildingSnapshots: Record<string, string>;
    metaSnapshot: any;
    createdCharacterIds?: string[];
    createdWorldbuildingIds?: string[];
  };
}

export interface RevertVisibilityInput {
  messageId: string;
  role: string;
  revertOptionsByAssistantMessageId: Map<string, RevertOption>;
  revertedAssistantMessageIds: Set<string>;
  isRevertedStoryBibleChange: boolean;
}

export interface RevertVisibilityResult {
  revertOption: RevertOption | undefined;
  revertTargetAssistantMessageId: string;
  showRevertButton: boolean;
}

/**
 * Determines whether an assistant message should show the Undo (revert) button.
 *
 * Each assistant message shows Undo only if it owns a restorable snapshot bundle
 * and has not already been reverted. There is NO fallback to an older turn's bundle.
 */
export function resolveRevertVisibility(input: RevertVisibilityInput): RevertVisibilityResult {
  const {
    messageId,
    role,
    revertOptionsByAssistantMessageId,
    revertedAssistantMessageIds,
    isRevertedStoryBibleChange,
  } = input;

  if (role !== "assistant") {
    return {
      revertOption: undefined,
      revertTargetAssistantMessageId: messageId,
      showRevertButton: false,
    };
  }

  const revertOption = revertOptionsByAssistantMessageId.get(messageId);
  const revertTargetAssistantMessageId = messageId;
  const showRevertButton =
    !isRevertedStoryBibleChange
    && !revertedAssistantMessageIds.has(messageId)
    && hasRestorableAgenticSnapshotBundle(revertOption?.snapshotBundle);

  return { revertOption, revertTargetAssistantMessageId, showRevertButton };
}
